// API Keys for the application
// In production, these should be environment variables

export const STRIPE_PUBLISHABLE_KEY = "pk_live_51REypmK1646FgCQVRgUQXoWI8Z9UVwQIv2bPG79Mc2epVWB8hDLBI3L5pfOPq3AbqNGO1xnPuZgPmeeVVvYhPWRO001bYv8zkP";
export const RAZORPAY_KEY_ID = "rzp_live_oYaXcxJ0UKqJQw";
export const GEMINI_API_KEY = "AIzaSyCTRkd1Kl83-yM8k1LILDJ19cm-0LgtPvA"; 